import { PDFParse } from "pdf-parse";
import { ensurePdfWorkerConfigured } from "./pdfWorker";

export async function extractTextFromPdfBytes(bytes: ArrayBuffer): Promise<string> {
  ensurePdfWorkerConfigured();

  const parser = new PDFParse({ data: new Uint8Array(bytes) });
  try {
    const result = await parser.getText();
    return result.text;
  } finally {
    // Do not block UI completion on worker teardown.
    void parser.destroy();
  }
}
